import { UrlResolver } from "../../util/UrlResolver";
import { CCCResponse } from "../model/CCCResponse";

export async function PerformCAuth(
  lossRef: string,
  lastName: string,
  urlKey: string,
  custKey: string,
  numberOfPhotos: number
): Promise<CCCResponse> {
  const URI = `${UrlResolver.resolveBaseUrl()}/cAuth`;
  const metaData = {
    lossRef: lossRef,
    lastName: lastName,
    numberOfPhotos: numberOfPhotos
  };
  var myHeaders = new Headers();
  myHeaders.append("urlid", urlKey);
  myHeaders.append("Authorization", "Bearer " + custKey);
  myHeaders.append("Accept", "application/json");
  myHeaders.append("Content-Type", "application/json");

  return fetch(URI, {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(metaData)
  })
    .then(response => {
      var resp = response.json();
      console.log("---------->  " + resp);
      return resp;
    })
    .catch(error => console.log("Failed to get CAuth Perform " + error));
}
